import styled from 'styled-components';

const LandingModalHelperText = styled.div`
  margin-top: 5px;
  color: red;
  font-style: italic;
  position: relative;
  top: 5px;
  text-align: center;
`;

export default LandingModalHelperText;
